const stringifyParams = (
  params?: Record<string, boolean | string | number | string[]>,
  joinArray = (arr) => arr.join(","),
) =>
  new URLSearchParams(
    params
      ? Object.entries(params)
          .filter(([k, v]) => {
            if (v === null || v === undefined) {
              console.error(`value with key: ${k} is null or undefined!`);

              return false;
            }

            return true;
          })
          .reduce(
            (acc, [k, v]) => ({
              ...{
                [k]: Array.isArray(v) ? joinArray(v) : v.toString(),
              },
              ...acc,
            }),
            [],
          )
      : {},
  );

export { stringifyParams };
